import PropTypes from 'prop-types';
import './StagePill.css';

// "Stage pill" — a mono, uppercase, tinted label with a leading dot.
// The intuitive layer over a diligencia's derived state (borrador → cerrada).
// Presentational only: it renders whatever {tone,label} it's handed; the
// status → stage/tone mapping lives in lib/diligenciaStage.js. Styles come from
// the global stylesheet (.stagepill in atoms.css).
const TONES = ['mute', 'info', 'ready', 'live', 'warn', 'err', 'ok'];

export default function StagePill({ tone = 'mute', label, style }) {
  return (
    <span className={`stagepill stagepill--${tone}`} style={style}>
      <span className="st__dot" />
      {label}
    </span>
  );
}

StagePill.propTypes = {
  tone: PropTypes.oneOf(TONES),
  label: PropTypes.node.isRequired,
  style: PropTypes.object,
};
